<template functional>
  <a
    :href="props.url"
    :target="props.openInNewTab ? '_blank' : null"
    :rel="props.openInNewTab ? 'noopener' : null"
    class="quick-link column"
    v-bind="data.attrs"
    v-on="listeners"
  >
    <span v-text="props.text"></span>
  </a>
</template>

<script>
export default {
  name: 'QuickLink',

  props: {
    openInNewTab: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.quick-link {
  align-items: center;
  border: 1px solid $grey;
  display: flex;
  font-size: 15px;
  font-weight: 700;
  justify-content: center;
  margin: 10px;
  min-height: 60px;
  padding: 7.5px;
  text-align: center;
  text-transform: uppercase;
  width: 100%;

  @include mobile {
    display: block;
    font-size: 16px;
    font-weight: 400;
    margin: 0;
    min-height: auto;
    border: none;
    border-top: 1px solid $grey;

    &:last-child {
      border-bottom: 1px solid $grey;
    }
  }
}
</style>
